const Utils = require("../common/Utils");
const postal = require("../common/PubSub");
const Controller = require("../common/Controller");

function LogonHandler(logonRequestFailureHandler, keepAlivePeriod) {
    Controller.call(this);
    const self = this;

    let logonRequest;
    let logonAttempts = 0;

    let logoffRequest;
    let logoffAttempts = 0;
    const MAX_LOGOFF_ATTEMPTS = 3;

    let propertyProviders = {};

    let pendingProperties = {};
    let submittedCredentials = {};

    const logonKeepAlivePeriod = keepAlivePeriod || 4.75 * 60 * 1000; // Default to every 4:45 minutes
    let unstartedLoginKeepAlive = undefined;

    this.addPropertyProvider = function(key, provider) {
        propertyProviders[key] = provider;
    };

    this.getViews = function() {
        return [];
    };

    this.onConnection = function(serverConfig, logonView) {
        postal.channel("LogonController").publish("set-custom-logo", {logo : serverConfig.customLogo});
        logonView.setWelcomeMessage(serverConfig.welcomeText);
        startLogonKeepAlive();
        this.logon({});
    };

    // Add wrapper around logon, so that it will only fire after any currently active logoff calls have completed.
    this.logon = function(params) {
        if (logoffRequest) {
            // There's currently a logoff request in progress, wait for that to successfully resolve before continuing
            return logoffRequest.done(function() {
                return performLogon(params);
            });
        }
        return performLogon(params);
    };

    // If we haven't truly started the logon process (i.e. the user hasn't entered any credentials)
    // send an empty logon request to the server so that the server side session isn't cleaned up.
    // We don't care about the result.
    function startLogonKeepAlive() {
        unstartedLoginKeepAlive = setInterval(function() {
            if (CudaLaunch.serverConfiguration.getSession().username === undefined) {
                $.ajax({
                    type : "POST",
                    url : App.getApiRoot() + "authentication/logon",
                    data : {}
                });
            }
        }, logonKeepAlivePeriod);
    }

    function performLogon(params) {
        if (!$.isEmptyObject(params) && unstartedLoginKeepAlive !== undefined) {
            clearInterval(unstartedLoginKeepAlive);
            unstartedLoginKeepAlive = undefined;
        }
        let deferred = $.Deferred();
        let logonFailed = false;
        let clearPersistentAuth = true;

        $.extend(params, pendingProperties);
        pendingProperties = {};

        logonRequest = $.ajax({
            type : "POST",
            url : App.getApiRoot() + "authentication/logon",
            data : params
        }).done(function(data) {
            const config = CudaLaunch.serverConfiguration;

            if (data.result === "SUCCESS") {
                setCompletedPersistentAuth(params);
                let session = config.getSession();

                // Add extra data to session from response
                session.customVpnAllowed = data.allowCustomVPNProfiles;
                session.username = data.username;
                session.completedAuthSchemes = submittedCredentials;
                session.key = data.sessionKey;
                session.token = data.sessionToken;

                if (!App.isSSLVPNApp()) {
                    session.totpKey = data.sessionKey;
                    session.totpToken = data.sessionToken;
                }

                if (Utils.isLessThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "8.0.0")) {
                    session.enrolledForTOTP = data.enrolledForGoogleAuth;
                    session.totpEnabled = data.googleAuthEnabled;
                    session.totpSelfEnroll = session.totpEnabled;
                }

                if (unstartedLoginKeepAlive !== undefined) {
                    clearInterval(unstartedLoginKeepAlive);
                    unstartedLoginKeepAlive = undefined;
                }

                $.event.trigger("userauthenticated", session);
                console.log("user was authenticated");
            } else if (data.result === "ERROR_MSG") {
                postal.channel("LogonController").publish("show-error", {message : data.msg, key : data.code});
            } else if (data.result === "ACCESS_DENIED") {
                let session = config.getSession();
                if (session.isCertOnly) {
                    // We need to break out of the infinite logon loop
                    postal.channel("LogonController").publish("show-error", {message : $.t("common::error.badClientCert.message", {0 : window.location.hostname}), noReturn : true});
                } else {
                    postal.channel("LogonController").publish("access-denied");
                }
            } else if (data.result === "INPUT_REQUIRED") {
                // Work out what we want and get the relevant provider to provide it
                clearPersistentAuth = false;
                setCompletedPersistentAuth(params);
                let props = data.requirements.properties;

                if (props) {
                    props.forEach(function(prop) {
                        let provider = propertyProviders[prop];

                        if (provider) {
                            // Store the property for later when we send the next request
                            pendingProperties[prop] = provider.getPropertyValue();
                        }
                    });
                }

                // TODO MFA -- what if we don't need to do anything else at this point?

                postal.channel("LogonController").publish("show-logon-view", {
                    usernameKey : (props && props.contains("username")) ? "username" : undefined,
                    authOptions : data.requirements.authentication
                });
            } else {
                // Something went badly wrong -- just show a generic error
                postal.channel("LogonController").publish("show-error", {message : "", key : "common::errorPage.message"});
            }
        }).fail(function(jqXHR) {
            // Handle specific fail (where request failed without any response from server)
            if (logonRequest.statusText === "error" && logonRequest.status === 0 &&
                    logonRequest.readyState === 0 && logonAttempts < 3) {
                logonAttempts++;
                logonFailed = true;
            } else {
                // Else proceed to error handler
                logonRequestFailureHandler.handle(jqXHR);
            }
        }).always(function() {
            // If logon failed without response from server, perform another attempt
            if (logonFailed) {
                self.logon(params);
            } else {
                logonAttempts = 0;
                logonFailed = false;
                logonRequest = undefined;

                if (clearPersistentAuth) {
                    submittedCredentials = {};
                }
                deferred.resolve();
            }
        });
        return deferred;
    }

    this.cancel = function() {
        if (logonRequest) {
            logonRequest.abort();
        }
    };

    this.logoff = function() {
        if (logoffRequest) {
            // We're already doing a logoff
            return;
        }
        logoffRequest = $.Deferred();
        makeLogoffRequest();
    };

    // Recursive function which calls itself on failure up to 3 times.
    const makeLogoffRequest = function() {
        $.ajax({
            url : App.getApiRoot() + "authentication/logoff",
            type : "POST"
        }).done(function() {
            // Execution is blocked until all listeners have completed, so the potential performLogon (line ~44)
            // which is waiting for a successful logoff won't be triggered until all the 'userunauthenticated'
            // listeners are "done". Of course the 'userunauthenticated' event could have its own async events...
            $.event.trigger("userunauthenticated");
            logoffRequest.resolve();
            logoffRequest = undefined;
            logoffAttempts = 0;
        }).fail(function(response) {
            if (response.status === 0) {
                logoffAttempts++;
                if (logoffAttempts < MAX_LOGOFF_ATTEMPTS) {
                    console.warn("Logoff call failed - trying again");
                    makeLogoffRequest();
                    return;
                }
                console.error("Logoff call failed " + MAX_LOGOFF_ATTEMPTS + " times - giving up");
                logoffAttempts = 0;
                logoffRequest.reject();
                logoffRequest = undefined;
            }
        });
    };

    function setCompletedPersistentAuth(params) {
        Object.keys(params).forEach(function(key) {
            if (key !== "username" && key !== "authSchemeSelector" && params[key] !== "") {
                submittedCredentials[key] = params[key];
            }
        });
    }
}

Utils.inherits(LogonHandler, Controller);

module.exports = LogonHandler;